import REQ from '../../utils/REQ';
import { PageBase } from '@components/page/base';

/**
 * @package
 */
export const PageLoading = () => {
  return <PageBase req={REQ.PENDING} />;
};
